<template>
  <v-row class="pt-2">
   <v-col>
      <div class="card-actions justify-start">
        <!-- <v-btn
          text
          class="action-btn csv-icon"
          :disabled="disabled"
        >
            <span class="icon-txt">CSV</span>
          <v-icon color="#000">insert_drive_file</v-icon>
        </v-btn> -->
        <div class="card-title-wrapper">
          <h4 class="card-title mr-1">Enterprise Digital Risk</h4>
          <p class="card-subtitle">(In Thousands)</p>
        </div>
        <v-btn
          color="#000"
          text
          class="action-btn"
          :disabled="disabled"
          @click="$emit('onCapture')"
        >
          <img style="position: relative; top: 6px" :src="require('@/assets/icons/camera.svg')" :alt="'file'">
        </v-btn>
      </div>
    </v-col>
    <v-col>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <div class="card-actions d-flex justify-start align-center fields">
          <div :style="{whiteSpace: 'nowrap'}" class="mr-2"> Risk Model </div>
          <div class="d-flex flex-column align-center">
              <p class="mb-1">Cost per record</p>
              <div class="d-flex">
                <v-text-field
                  v-model="min"
                  label="Min"
                  type="number"
                  solo
                  prefix='$'
                  class="select-field"
                  single-line
                  :rules="[v => v >= 0 || 'Must be positive']"
                  :disabled="disabled"
                  :loading="riskEnterpriseLoading"
                  @input="handleChange($event,'min')"
                />
                <v-text-field
                  v-model="max"
                  label="Max"
                  type="number"
                  solo
                  prefix='$'
                  class="select-field"
                  single-line
                  :rules="[v => v >= 0 || 'Must be positive']"
                  :disabled="disabled"
                  :loading="riskEnterpriseLoading"
                  @input="handleChange($event,'max')"
                />
              </div>
          </div>
          <div class="d-flex ml-5 flex-column align-center">
              <p class="mb-1">Cyber Discount</p>
              <div class="d-flex">
                <v-text-field
                  v-model="cyberDiscount"
                  solo
                  type="number"
                  class="select-field cyber-discount"
                  suffix='%'
                  single-line
                  :disabled="false"
                  :min="0"
                  :max="100"
                  :loading="riskEnterpriseLoading"
                  @input="handleChange($event,'discount')"
                />
              </div>
          </div>
      </div>
          <div class="err ml-5 mb-3 " v-if="error"> minimun cost per record cannot be greater than maximun cost per record
          </div>
      </v-form>
    </v-col>

  </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'EnterpriseRiskActions',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      min: '60.36',
      max: '208.00',
      timer: null,
      valid: true,
      cyberDiscount: 0,
      error: false
    }
  },
  computed: {
    ...mapState('dashboardServices', ['riskEnterpriseLoading', 'organizationChanged'])

  },
  methods: {
    validate () {
      this.$refs.form.validate()
    },
    handleChange (e, v, immediate = false) {
      if (v == 'min' && parseFloat(this.max) < parseFloat(e)) {
        this.min = this.max
        this.error = true
      } else if (v == 'max' && parseFloat(this.min) > parseFloat(e)) {
        this.max = this.min
        this.error = true
      } else if (v == 'discount') {
        this.cyberDiscount = e > 100 ? 100 : e < 0 ? 0 : e
      } else {
        this.error = false
      }
      const cd = (this.cyberDiscount / 100).toFixed(2)
      if (immediate) {
        this.$emit('onMinMaxChange', { min: parseFloat(this.min), max: parseFloat(this.max), cyberDiscount: cd })
        return
      }
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.validate()
        if (!this.valid) return
        this.$emit('onMinMaxChange', { min: parseFloat(this.min), max: parseFloat(this.max), cyberDiscount: cd })
      }, 300)
    }
  },
  watch: {
    organizationChanged () {
      this.min = '60.36'
      this.max = '208.00'
      this.cyberDiscount = 0
    }
  }
}
</script>

<style lang="scss">
  .card-actions {
    &.fields {
        font-weight: 500;
        font-size: 12px;
       .select-field {
          .v-input__slot {
                 background: #e2e2e2;
          }
       }
       .cyber-discount{
         .v-input__slot {
            background: #e2e2e2;
            width: 85px;
          }
       }
      .v-input {
         font-weight: 400;
        max-width: 110px;
        margin: 0 10px;

        &__slot {
           background: #F4F7F9 !important;
        }
      }
      .v-text-field__details {
        position: absolute;
        top: 60px;
      }
    }
  }
  .err{
    color: red;
  }
</style>
